
import './leaflet.draw.js'
import './leaflet.draw.css'
var isDrawing = false; //是否正在绘制
var drawLayers = [];
var barDrawLayers = [];
var isMeasure = false;  //是否是量距
var measureLineToolTip;  //量距提示
var measureAreaToolTip;  //量面提示
var measureResult = 0;

var drawPolyLine; //绘制的折线
var drawMovePolyLine; //绘制过程中的折线
var drawPolyLinePoints = []; //绘制的折线的节点集


var drawPolygon; //绘制的面
var drawMovePolygon; //绘制过程中的面
var drawPolygonPoints = []; //绘制的面的节点集

var rectangleLayers = []; //

//地图测量工具
//绘制折线
function startDrawLine(map, func) {

    measureResult = 0;
    map.getContainer().style.cursor = 'crosshair';
    map.on('mousedown', function (e) {
        isDrawing = true;
        drawPolyLinePoints.push(e.latlng);
        if (drawPolyLinePoints.length > 1 && isMeasure) {
            measureResult += e.latlng.distanceTo(drawPolyLinePoints[drawPolyLinePoints.length - 2]);
        }
        drawPolyLine.addLatLng(e.latlng);
    });
    map.on('mousemove', function (e) {
        if (isDrawing) {
            if (drawMovePolyLine != undefined && drawMovePolyLine != null) {
                map.removeLayer(drawMovePolyLine);
            }
            var prevPoint = drawPolyLinePoints[drawPolyLinePoints.length - 1];
            drawMovePolyLine = new L.Polyline([prevPoint, e.latlng], shapeOptions);
            map.addLayer(drawMovePolyLine);

            if (isMeasure) {
                var distance = measureResult + e.latlng.distanceTo(drawPolyLinePoints[drawPolyLinePoints.length - 1]);
                measureLineToolTip.updatePosition(e.latlng);
                measureLineToolTip.updateContent({
                    text: '单击确定点，双击结束！',
                    subtext: "总长：" + (distance / 1000).toFixed(2) + "公里"
                });
            }

        }
    });
    map.on('dblclick', function (e) {
        map.getContainer().style.cursor = '';
        if (isDrawing) {

            if (drawMovePolyLine != undefined && drawMovePolyLine != null) {
                map.removeLayer(drawMovePolyLine);
                drawMovePolyLine = null;
            }

            if (drawPolyLinePoints.length > 1 && isMeasure) {

                measureResult += e.latlng.distanceTo(drawPolyLinePoints[drawPolyLinePoints.length - 2]);

                var distanceLabel = L.marker(drawPolyLinePoints[drawPolyLinePoints.length - 1], {
                    icon: new L.divIcon({
                        className: 'DistanceLabelStyle',
                        iconAnchor: [-8, 15],
                        html: "<span class='bubbleLabel'><span class='bubbleLabel-bot bubbleLabel-bot-left'></span><span class='bubbleLabel-top bubbleLabel-top-left'></span><span>总长：" + (measureResult / 1000).toFixed(2) + "公里" + "</span></span>"
                    }),
                }).addTo(map);

                barDrawLayers.push(distanceLabel);
            }

            //移除提示框
            if (measureLineToolTip) {
                measureLineToolTip.dispose();
            }

            barDrawLayers.push(drawPolyLine);

            if (func) {
                func(drawPolyLinePoints);
            }

            drawPolyLinePoints = [];
            isDrawing = false;
            isMeasure = false;
            map.off('mousedown');
            map.off('mousemove');
            map.off('dblclick');
        }
    });

    var shapeOptions = {
        color: '#F54124',
        weight: 3,
        opacity: 0.8,
        fill: false,
        clickable: true
    },

        drawPolyLine = new L.Polyline([], shapeOptions);
    map.addLayer(drawPolyLine);
    if (isMeasure) {
        measureLineToolTip = new L.Tooltip(map);
    }
}

//面积计算
function CalArea(latLngs) {
    var pointsCount = latLngs.length,
        area = 0.0,
        d2r = Math.PI / 180,
        p1, p2;
    if (pointsCount > 2) {
        for (var i = 0; i < pointsCount; i++) {
            p1 = latLngs[i];
            p2 = latLngs[(i + 1) % pointsCount];
            area += ((p2.lng - p1.lng) * d2r) *
                (2 + Math.sin(p1.lat * d2r) + Math.sin(p2.lat * d2r));
        }
        area = area * 6378137.0 * 6378137.0 / 2.0;
    }
    return Math.abs(area);
}
//绘制多边形
function startDrawPolygon(map, func) {
    measureResult = 0;
    map.getContainer().style.cursor = 'crosshair';
    map.on('mousedown', function (e) {
        isDrawing = true;
        drawPolygonPoints.push(e.latlng);
        drawPolygon.addLatLng(e.latlng);
    });
    map.on('mousemove', function (e) {
        if (isDrawing) {
            if (drawMovePolygon != undefined && drawMovePolygon != null) {
                map.removeLayer(drawMovePolygon);
            }
            var prevPoint = drawPolygonPoints[drawPolygonPoints.length - 1];
            var firstPoint = drawPolygonPoints[0];
            drawMovePolygon = new L.Polygon([firstPoint, prevPoint, e.latlng], shapeOptions);
            map.addLayer(drawMovePolygon);

            if (isMeasure && drawPolygonPoints.length > 1) {
                var tempPoints = [];
                for (var i = 0; i < drawPolygonPoints.length; i++) {
                    tempPoints.push(drawPolygonPoints[i]);
                }
                tempPoints.push(e.latlng);
                var distance = CalArea(tempPoints);
                measureAreaToolTip.updatePosition(e.latlng);
                measureAreaToolTip.updateContent({
                    text: '单击确定点，双击结束！',
                    subtext: "总面积：" + (distance / 1000000).toFixed(3) + '平方公里'
                });
            }
        }
    });
    map.on('dblclick', function (e) {

        map.getContainer().style.cursor = '';

        if (isDrawing) {

            if (drawMovePolygon != undefined && drawMovePolygon != null) {
                map.removeLayer(drawMovePolygon);
                drawMovePolygon = null;
            }

            if (drawPolygonPoints.length > 2 && isMeasure) {

                measureResult = CalArea(drawPolygonPoints);

                var distanceLabel = L.marker(e.latlng, {
                    icon: new L.divIcon({
                        className: 'DistanceLabelStyle',
                        iconAnchor: [-8, 15],
                        html: "<span class='bubbleLabel'><span class='bubbleLabel-bot bubbleLabel-bot-left'></span><span class='bubbleLabel-top bubbleLabel-top-left'></span><span>总面积：" + (measureResult / 1000000).toFixed(3) + "平方公里" + "</span></span>"
                    }),
                }).addTo(map);

                barDrawLayers.push(distanceLabel);
            }

            //移除提示框
            if (measureAreaToolTip) {
                measureAreaToolTip.dispose();
            }

            barDrawLayers.push(drawPolygon);

            if (func) {
                func(drawPolygonPoints);
            }

            drawPolygonPoints = [];
            isDrawing = false;
            isMeasure = false;
            map.off('mousedown');
            map.off('mousemove');
            map.off('dblclick');
        }
    });

    var shapeOptions = {
        color: '#F54124',
        weight: 3,
        opacity: 0.8,
        fill: true,
        fillColor: null,
        fillOpacity: 0.2,
        clickable: true
    },

        drawPolygon = new L.Polygon([], shapeOptions);
    map.addLayer(drawPolygon);

    if (isMeasure) {
        measureAreaToolTip = new L.Tooltip(map);
    }
}
function clearMap(map) {
    if (measureLineToolTip) {
        measureLineToolTip.dispose();
    }
    if (measureAreaToolTip) {
        measureAreaToolTip.dispose();
    }
    for (var i = 0; i < barDrawLayers.length; i++) {
        map.removeLayer(barDrawLayers[i]);
    }
    barDrawLayers = [];
    for (var i = 0; i < rectangleLayers.length; i++) {
        map.removeLayer(rectangleLayers[i]);
    }
    rectangleLayers = [];
    // //去掉之前的框选图层
    // $.each(mapKuangXuanLayers, function (index, obj) {
    //     obj.layer.eachLayer(function (layer) {
    //         map.removeLayer(layer);
    //     });
    // });
}
function startMeasureLine(map) {
    isMeasure = true;
    startDrawLine(map);
}

function measureArea(map) {
    isMeasure = true;
    startDrawPolygon(map);
}

export default {
    startMeasureLine: function (map) {
        return startMeasureLine(map);
    },
    startMeasureArea: function (map) {
        return measureArea(map);
    },
    clearMap:function(map){
        return clearMap(map);
    }
}